import React, { Component } from 'react';
import './index.scss';
import Loader from '../../pages/loader';
import * as API from '../../configuration/apiconfig';
import MemberCardLogin from './MemberCardLogin';
import PhoneNumberLogin from './PhoneNumberLogin';
import EmailLogin from './EmailLogin';

export class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      barcodeModalSH: false,
      layoutName: '',
      memberCardNumber: '',
      scanBarCodeBtnClick: false,
      manualBarCodeBtnClick: false,
      keyboardInputClickManually: false,
      loginErrorMsg: '',
      scanBarcodeLoaderMsg: 'Barcode scanning in progress',
      loginType: '',
      activeKeyboard: '',
      phoneNumber: '',
      email: '',
    };
  }

  componentDidMount = () => {
    window.winvar = this;
    localStorage.removeItem('endTimeInSecs');
    localStorage.removeItem('BookingCountdown');

    let orderType = localStorage.getItem('orderType');
    if (localStorage.getItem('orderId') != null && orderType == 'fnb' && localStorage.getItem('giftCardSwipeInit') != null) {
      var orderDetails = JSON.parse(localStorage.getItem('orderId'));
      if (orderDetails?.id) {
        localStorage.removeItem('giftCardSwipeInit');
        window.callbackObj.callAbortTransaction(orderDetails.id, 'failure', 'Sorry', 'Swipe cancelled');
      }

      this.deleteOrder();
      localStorage.removeItem('orderId');
    }
  };

  componentDidUpdate = (prevProps, prevState) => {};

  handleLoginTypeChange = type => {
    this.setState({
      loginType: type,
      activeKeyboard: type,
    });
  };

  handleKeyboardToggle = type => {
    this.phoneRef?.closeKeyboard();
    this.emailRef?.closeKeyboard();
    this.resetErrorMsg();

    if (type === 'phone') {
      this.emailChange('');
      this.phoneRef?.openKeyboard();
    } else if (type === 'email') {
      this.phoneNumberChange('');
      this.emailRef?.openKeyboard();
    }
  };

  deleteOrder = () => {
    var orderDetails = JSON.parse(localStorage.getItem('orderId'));
    if (orderDetails?.id) {
      API.callEndpoint('DELETE', 'Bearer', `/order/v2/orders/${orderDetails.id}`)
        .then(response => {
          console.log(response);
        })
        .catch(ex => {
          console.log(ex.error);
        });
    }
  };

  guestUser = async () => {
    // When session expiry in login user > delete order
    if (window.constant.ENABLE_VOUCHERS == 'true') {
      window.location.href = `/addvouchers`;
    } else {
      if (localStorage.getItem('sessionExpiredRedirectUrl') != null && localStorage.getItem('orderId') != null) {
        this.setState({
          loader: true,
        });
        var orderDetails = JSON.parse(localStorage.getItem('orderId'));
        await API.callEndpoint('DELETE', 'Bearer', `/order/v2/orders/${orderDetails.id}`)
          .then(response => {
            localStorage.removeItem('selectedSeats');
            localStorage.removeItem('orderId');
            localStorage.removeItem('cartData');
            localStorage.removeItem('sessionExpiredRedirectUrl');
            this.setState({ loader: false });
          })
          .catch(err => {
            console.log(err.error, 'delete error');
            this.setState({ loader: false });
          });
      }

      const isFnbFlow = localStorage.getItem('orderType') === 'fnb';
      const cinemaId = localStorage.getItem('cinemaid');
      if (isFnbFlow) {
        window.location.href = `fnb?cinemaid=${cinemaId}`;
      } else {
        var getSessionIdFromLocalstorage = localStorage.getItem('sesstionid');
        window.location.href = `/seatlayout?sessionid=${getSessionIdFromLocalstorage}`;
      }
    }
  };

  phoneNumberChange = phoneNumber => {
    this.setState({ phoneNumber });
  };

  emailChange = email => {
    this.setState({ email });
  };

  moveToNextPage = () => {
    let orderType = localStorage.getItem('orderType');
    if (orderType == 'ticketing') {
      var getSessionIdFromLocalstorage = localStorage.getItem('sesstionid');
      var redirectURL = window.constant.ENABLE_VOUCHERS == 'true' ? '/addvouchers' : `/seatlayout?sessionid=${getSessionIdFromLocalstorage}`;

      window.location.href = redirectURL;
    } else {
      var getCinemaIdFromLocalstorage = localStorage.getItem('cinemaid');
      var redirectURL = window.constant.ENABLE_VOUCHERS == 'true' ? '/addvouchers' : `/fnb?cinemaid=${getCinemaIdFromLocalstorage}`;

      window.location.href = redirectURL;
    }
  };

  validateEmail = email => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  disableContinueBtn = () => {
    let disabled = true;
    if (this.state.phoneNumber.length == 10 || this.validateEmail(this.state.email)) {
      disabled = false;
    }
    return disabled;
  };

  resetErrorMsg = () => {
    this.setState({
      loginErrorMsg: '',
    });
  };

  loginByPhoneAndEmail = () => {
    let loginType = this.state.phoneNumber.length == 10 ? 'phoneNumber' : 'email';
    this.setState(
      {
        loader: true,
        loginErrorMsg: '',
      },
      () => {
        var data = new Object();
        if (loginType === 'phoneNumber') {
          data.phoneNumber = this.state.phoneNumber;
        } else {
          data.email = this.state.email;
        }

        API.userLogin(loginType, data)
          .then(response => {
            document.cookie = 'accessToken=' + response.data.accessToken;
            document.cookie = 'refreshToken=' + response.data.refreshToken;
            document.cookie = 'phonenumber=' + this.state.phoneNumber;
            document.cookie = 'firstname=' + response.data.firstname;
            document.cookie = 'lastname=' + response.data.lastname;

            this.moveToNextPage();
          })
          .catch(ex => {
            console.log(ex.error);

            if (loginType === 'phoneNumber') {
              const loginModules = JSON.parse(window.constant.LOGIN_MODULE);
              const checkPhoneErrorType = loginModules.find(module => module.loginType === 'phonenumber');
              const { showError } = checkPhoneErrorType.options;

              if (showError === 'true') {
                this.setState({
                  loader: false,
                  loginErrorMsg: ex.error ? ex.error : 'Something went wrong. Please try again or contact support.',
                });
              } else {
                this.setState({
                  loader: false,
                });
                document.cookie = 'guestphonenumber=' + this.state.phoneNumber;
                this.guestUser();
              }
            } else {
              this.setState({
                loader: false,
                loginErrorMsg: ex.error ? ex.error : 'Something went wrong. Please try again or contact support.',
              });
            }
          });
      }
    );
  };

  render() {
    const renderedLoginTypes = [];
    const loginModules = JSON.parse(window.constant.LOGIN_MODULE);
    const dynamicComponent = loginModules.find(module => module.loginType === 'dynamicComponent' && module.isActive === 'true');
    const activeModules = loginModules.filter(item => item.isActive === 'true');

    if (dynamicComponent && dynamicComponent.hasOwnProperty('loginTypes')) {
      loginModules.forEach(module => {
        if (dynamicComponent.loginTypes.includes(module.loginType)) {
          renderedLoginTypes.push(module);
        }
      });
    } else {
      renderedLoginTypes.push(...activeModules);
    }

    let checkIfContinueBtnRequired = renderedLoginTypes.filter(item => item.loginType == 'phonenumber' || item.loginType == 'email');

    return (
      <React.Fragment>
        <Loader loader={this.state.loader} />
        <section className="content">
          <div className="loginComponent">
            {renderedLoginTypes.map(module => {
              if (module.loginType === 'membercard') {
                return (
                  <MemberCardLogin
                    key="membercard"
                    timerIncrement={this.props.timerIncrement}
                    timerDecrement={this.props.timerDecrement}
                    dynamicComponent={dynamicComponent ? true : false}
                    handleKeyboardToggle={this.handleKeyboardToggle}
                  />
                );
              }
              if (module.loginType === 'phonenumber') {
                return (
                  <div>
                    <PhoneNumberLogin
                      ref={ref => (this.phoneRef = ref)}
                      toggleKeyboard={this.handleKeyboardToggle}
                      setLoginType={this.handleLoginTypeChange}
                      activeKeyboard={this.state.activeKeyboard}
                      continueAsGuestUser={this.guestUser}
                      dynamicComponent={dynamicComponent ? true : false}
                      phoneNumberChange={this.phoneNumberChange}
                      phoneNumber={this.state.phoneNumber}
                      loginErrorMsg={this.state.loginErrorMsg}
                    />
                  </div>
                );
              }
              if (module.loginType === 'email') {
                return (
                  <EmailLogin
                    ref={ref => (this.emailRef = ref)}
                    toggleKeyboard={this.handleKeyboardToggle}
                    setLoginType={this.handleLoginTypeChange}
                    activeKeyboard={this.state.activeKeyboard}
                    continueAsGuestUser={this.guestUser}
                    dynamicComponent={dynamicComponent ? true : false}
                    emailChange={this.emailChange}
                    email={this.state.email}
                    loginErrorMsg={this.state.loginErrorMsg}
                  />
                );
              }
              return null;
            })}
            {checkIfContinueBtnRequired.length ? (
              <div className="continue-btn">
                <a onClick={this.loginByPhoneAndEmail} href="javascript:;" className={`btn btnPrimary ${this.disableContinueBtn() ? 'disabled' : ''}`} title="SUBMIT">
                  CONTINUE
                </a>
              </div>
            ) : null}
            <div
              className={`procced-text ${this.props.hasOwnProperty('loginPageImage') && this.props.loginPageImage != '' ? 'has-image-pack' : ''} ${dynamicComponent ? ' dynamic-component-login' : ''}`}
            >
              <p>
                <span>OR</span>{' '}
                <a onClick={this.guestUser} href="javascript:;" title="PROCEED AS A GUEST">
                  PROCEED AS A GUEST
                </a>
              </p>
            </div>
          </div>
        </section>
        {this.props.hasOwnProperty('loginPageImage') && this.props.loginPageImage != '' && (
          <div className="login-image-pack">
            <img src={this.props.loginPageImage} alt="login page banner" />
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default index;
